import React, { useState } from "react";
import LegalModel from "../models/LegalModel";

const Footer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState(null);

  const openModal = (section) => {
    setCurrentSection(section);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentSection(null);
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-brand">
              <p className="footer-title">Naoko.live</p>
              <p className="footer-tagline">Your virtual companion</p>
            </div>

            <div className="footer-links">
              <button 
                onClick={() => openModal("privacy")}
                className="footer-link"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => openModal("terms")}
                className="footer-link"
              >
                Terms & Conditions
              </button>
              <button 
                onClick={() => openModal("faq")}
                className="footer-link"
              >
                FAQ
              </button>
            </div>

            <div className="footer-contact">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <a href="mailto:support@naoko.live" className="contact-link">
                  support@naoko.live
                </a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>Viewland, Ukhrul, Manipur 795142</span>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p className="footer-copy">
              &copy; {new Date().getFullYear()} Naoko. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Modal - Reverted to original behavior */}
      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            <LegalModel section={currentSection} />
          </div>
        </div>
      )}

      <style jsx>{`
        .footer {
          background: linear-gradient(135deg, #0a0a0a 0%, #101010 100%);
          padding: 50px 0 20px;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          color: #eee;
          position: relative;
          overflow: hidden;
        }
        
        .footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
        }

        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 40px;
          margin-bottom: 40px;
        }

        .footer-brand {
          display: flex;
          flex-direction: column;
        }

        .footer-title {
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 8px;
          color: #ffffff;
          letter-spacing: -0.5px;
        }

        .footer-tagline {
          font-size: 14px;
          color: rgba(255,255,255,0.6);
          margin-bottom: 0;
        }

        .footer-links {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .footer-link {
          background: none;
          border: none;
          padding: 0;
          font-size: 15px;
          color: #a0c4ff;
          cursor: pointer;
          text-decoration: none;
          text-align: left;
          transition: all 0.2s ease;
          display: inline-block;
        }

        .footer-link:hover {
          color: #4da6ff;
          transform: translateX(3px);
        }

        .footer-contact {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: rgba(255,255,255,0.7);
        }

        .contact-icon {
          opacity: 0.7;
        }

        .contact-link {
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          transition: color 0.2s ease;
        }

        .contact-link:hover {
          color: #a0c4ff;
          text-decoration: underline;
        }

        .footer-bottom {
          border-top: 1px solid rgba(255,255,255,0.05);
          padding-top: 20px;
          text-align: center;
        }

        .footer-copy {
          font-size: 13px;
          color: rgba(255,255,255,0.5);
          margin: 0;
        }

        /* Modal styles - keeping your original functionality */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .modal-content {
          background: white;
          padding: 30px;
          border-radius: 10px;
          max-height: 80vh;
          overflow-y: auto;
          max-width: 800px;
          width: 90%;
          position: relative;
          color: #333;
        }

        .modal-close {
          position: absolute;
          top: 10px;
          right: 15px;
          background: none;
          border: none;
          font-size: 24px;
          color: #333;
          cursor: pointer;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .footer-content {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          
          .footer-links {
            flex-direction: row;
            flex-wrap: wrap;
          }
          
          .modal-content {
            padding: 30px 20px;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;